import { profile } from '../../data/profile';
import './Layout.css';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <p>
          © {year} YuFy · Powered by passion &amp; code<span className="cursor" />
        </p>
        <p style={{ marginTop: '0.5rem' }}>
          <a href={profile.github} target="_blank" rel="noopener noreferrer">GitHub</a>
          {' · '}
          <a href={profile.archive} target="_blank" rel="noopener noreferrer">Archive</a>
          {' · '}
          <a href={profile.resume} target="_blank" rel="noopener noreferrer">Resume</a>
        </p>
      </div>
    </footer>
  );
}
